import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../icons/eye.svg'


const _hoisted_1 = { class: "password-eye" }

import { Ref, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordInput',
  emits: ["pass_change", "enter"],
  setup(__props, { emit }) {



const password_input = ref() as Ref<HTMLInputElement>;

const showPassword = (show: boolean) => {
  if (show) {
    password_input.value.type = "text";
  } else {
    password_input.value.type = "password";
  }
};

const handleKeyPress = (ev: Event) => {
  if (ev.keyCode == 13) {
    emit("enter");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      onInput: _cache[0] || (_cache[0] = 
        (e) => {
          emit('pass_change', e.target.value);
        }
      ),
      onChange: _cache[1] || (_cache[1] = 
        (e) => {
          emit('pass_change', e.target.value);
        }
      ),
      onKeypress: handleKeyPress,
      class: "password",
      type: "password",
      placeholder: "Entrez votre mot de passe",
      ref_key: "password_input",
      ref: password_input
    }, null, 544),
    _createElementVNode("img", {
      onMousedown: _cache[2] || (_cache[2] = ($event: any) => (showPassword(true))),
      onMouseup: _cache[3] || (_cache[3] = ($event: any) => (showPassword(false))),
      class: "eye",
      src: _imports_0,
      alt: ""
    }, null, 32)
  ]))
}
}

})